module.exports = __webpack_public_path__ + "img/shield-user-line.046c727a.svg";